
// react-bootstrap imports
import { useState } from "react"
import { Button, Container, Col, Row } from "react-bootstrap"

import { LoadingSpinner } from "components/Helpers"
import { CheckHealthLogin, CheckHealthDora, CheckHealthGeradoc, GerarDoc, SalvarDocumento } from "services/CallAPIs"

import { criarDocBodyBD } from "models/BodyDocumentosBD"
import { body } from "constants/testDocBodies"

import allDocServs from "json/ServicosGeradorDoc.json"


async function ChecarSaudeLogin(setIsLoading)
{
    setIsLoading(true)
    try
    {
        await CheckHealthLogin()
        alert("Login está acordado")
    }
    catch
    {
        alert("Login está dormindo")
    }
    setIsLoading(false)
}

async function ChecarSaudeDora(setIsLoading)
{
    setIsLoading(true)
    try
    {
        await CheckHealthDora()
        alert("Dora está acordada")
    }
    catch
    {
        alert("Dora está dormindo")
    }
    setIsLoading(false)
}

async function ChecarSaudeGeradoc(setIsLoading)
{
    setIsLoading(true)
    try
    {
        await CheckHealthGeradoc()
        alert("Geradoc está acordado")
    }
    catch
    {
        alert("Geradoc está dormindo")
    }
    setIsLoading(false)
}

// async function ChecarDocsGeradoc(setIsLoading)
// {
//     setIsLoading(true)
//     try
//     {
//         const docsComErro = await CheckDocsFuncionandoGeradoc()
//         alert(docsComErro)
//     }
//     catch (erro)
//     {
//         alert("Não deu pra verificar os documentos. Motivo: " + erro.message)
//     }
//     setIsLoading(false)
// }
async function ChecarGeracaoDocsFront(setIsLoading)
{
    const msgSucesso = "Todos os documentos gerados com sucesso!"
    let allDocIDs = []
    let docsComErro = []

    // for (let tipoServico of allDocServs)
    // {
    //     for (let docServ of tipoServico.servicos)
    //     {
    //         allDocIDs.push(docServ.idServ)
    //     }
    // }
    allDocIDs.push("AlvaraUnires")

    // const docBody = generateRandomDocBody()
    // const docData = generateRandomDocData()
    // const taxResults = generateRandomTaxResults()
    setIsLoading(true)
    const mockTaxInput = {
        "tipoImovel": "Uniresidencial",
        "areaConstruida": "23"
    }

    const mockTaxResults = {
        "TaxaBasica": "0.0",
        "Desconto": "0.0",
        "Outorga": "0.0",
        "TaxaTotal": "0.0",
        "obsDetCalc": "",
        "obsTaxaTotal": "",
        "DetalhesDoCalculo": {
            "Taxa de licença": "Taxa de licença: R$ 0,0"
        },
        "DetalhesDaAvaliacao": {
            "complexidade": "Categoria de complexidade = simples"
        },
        "MetodoDeCalculo": {
            "Taxa de licença": "Taxa de licença = isento (área construída até 80 m²)"
        }
    }

    for (let idServ of allDocIDs)
    {
        // console.log(idServ)
        // const input = MapInputsToDocBody(idServ, undefined, true, undefined, undefined)
        // const geradoComSucesso = await DownloadDocument(idServ, input, "")
        const todayDate = new Date()
        const filename = idServ + " - " + todayDate.getDate() + "_" + (todayDate.getMonth() + 1) + "_" + todayDate.getFullYear()
        const docData = {}
        const inputDB = criarDocBodyBD(idServ, mockTaxInput, docData, mockTaxResults)
        const geradoComSucesso = await GerarDoc(inputDB, filename, "00.000", 0, false)
        if (400 <= geradoComSucesso.status)
        {
            docsComErro.push(idServ + " ")
        }
    }

    alert(docsComErro.length <= 0 ? msgSucesso : "Erro nos seguintes documentos: " + docsComErro)
    console.log(docsComErro.length <= 0 ? msgSucesso : "Erro nos seguintes documentos: " + docsComErro)
    setIsLoading(false)
}

async function ChecarSalvarDoc(setIsLoading)
{
    const msgSucesso = "Documento salvo no banco de dados com sucesso!"
    const msgFail = "Erro ao tentar salvar documento no banco"

    setIsLoading(true)
    const docBody = criarDocBodyBD("AlvaraUnires", {}, {})
    const response = await SalvarDocumento("0", 2024, docBody)
    alert(response.status <= 299 || !response.status ? msgSucesso : msgFail)
    setIsLoading(false)
}

export function TestesScreen()
{
    const [isLoading, setIsLoading] = useState(false)

    const BotaoChecarSaudeLogin = () => { return <Button onClick={() => {ChecarSaudeLogin(setIsLoading)}}>Checar saúde</Button>}
    const BotaoChecarSaudeDora = () => { return <Button onClick={() => {ChecarSaudeDora(setIsLoading)}}>Checar saúde</Button>}
    const BotaoChecarSaudeGeradoc = () => { return <Button onClick={() => {ChecarSaudeGeradoc(setIsLoading)}}>Checar saúde</Button>}
    // const BotaoChecarDocsGeradoc = () => { return <Button onClick={() => {ChecarDocsGeradoc(setIsLoading)}}>Checar docs</Button>}
    const BotaoChecarGeracaoDocsFront = () => { return <Button onClick={() => {ChecarGeracaoDocsFront(setIsLoading)}}>Checar docs integrado</Button>}
    const BotaoSalvarDoc = () => { return <Button onClick={() => {ChecarSalvarDoc(setIsLoading)}}>Checar salvar doc</Button>}

    return (
        <>
            <LoadingSpinner show={isLoading} />

            <Container className="bg-white border border-dark rounded-4 text-dark my-2">
                <Row className="align-items-center mt-3">
                    <Col>Login</Col>
                    <Col><BotaoChecarSaudeLogin /></Col>
                </Row>
                <hr />
                <Row className="align-items-center">
                    <Col>Calculadora de taxas</Col>
                    <Col><BotaoChecarSaudeDora /></Col>
                </Row>
                <hr />
                <Row className="align-items-center">
                    <Col>Gerador de documentos</Col>
                    <Col><BotaoChecarSaudeGeradoc /></Col>
                    {/* <Col><BotaoChecarDocsGeradoc /></Col> */}
                    <Col><BotaoChecarGeracaoDocsFront /></Col>
                </Row>
                <hr />
                <Row className="align-items-center mb-3">
                    <Col>Banco de dados de documentos</Col>
                    <Col><BotaoSalvarDoc /></Col>
                </Row>
            </Container>
        </>
        
    )
}